<template>
  <div class="material-categories">
    <p>читайте больше интересных статей в&nbsp;других категориях нашего медиа</p>
    <div class="material-categories__categories">
      <nuxt-link
        class="m-btn"
        to="/articles"
      >
        все статьи
      </nuxt-link>
      <nuxt-link
        v-for="category in categories"
        :key="category.id"
        class="m-btn"
        :to="`/${category.slug}`"
      >
        {{ category.name }}
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MaterialCategories',
  async fetch() {
    await this.$store.dispatch('fetchMaterialCategories');
  },
  computed: {
    ...mapGetters({
      categories: 'getMaterialCategories',
    }),
  },
};
</script>

<style scoped lang="scss">

.material-categories {
  padding: calc(var(--scale) * 20);
  background-color: #ECEDF0;
  border-radius: calc(var(--scale) * 40);

  @include media-down($size-tablet) {
    padding: calc(var(--scale) * 16);
    border-radius: calc(var(--scale) * 24);
  }

  p {
    margin-bottom: calc(var(--scale) * 12) ;
    font-weight: 400;
    font-size: calc(var(--scale) * 20);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      font-size: calc(var(--scale) * 16);
      letter-spacing: -0.02em;
    }
  }

  .material-categories__categories {
    display: flex;
    flex-wrap: wrap;
    gap: calc(var(--scale) * 2);

    a {
      padding: calc(var(--scale) * 8) calc(var(--scale) * 14) calc(var(--scale) * 10);
      background-color: #FFFFFF;
      border-radius: calc(var(--scale) * 40);

      text-transform: lowercase;
      font-weight: 500;
      font-size: calc(var(--scale) * 16);
      line-height: 130%;
      color: #02120F;

      @include media-down($size-tablet) {
        padding: calc(var(--scale) * 6) calc(var(--scale) * 12) calc(var(--scale) * 8);
      }

      &:hover {
        color: #5237E6;
      }
    }
  }
}

</style>
